import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ContextCard from 'components/molecules/Cards/ContextCard/ContextCard';
import {rgba} from 'polished';

const StyledTasksContextCard = styled(ContextCard)`
  &.TasksContextCard {
    .ContextCard-content {
      padding: 0;
      .TasksList {
        padding: 0;
        
        .DataList-list {
          max-height: ${props => props.theme.layout(140)};
        }
      }
    }
    
    .ContextCard-header {
      .MuiCardHeader-action {
        margin-right: ${props => props.theme.layout('0.5sp')};
      }
    }
  }

  .TasksContextCard {
    &-empty {
      width: 100%;
      text-align: center;
      color: ${props => rgba(props.theme.property('palette.text.primary'), props.theme.property('palette.action.disabledOpacity'))};
      font-style: italic;

      .P {
        white-space: pre-line;
        margin: 0;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledTasksContextCard.propTypes = {
  theme: PropTypes.object
};

export default StyledTasksContextCard;
